module.exports = __webpack_public_path__ + "static/zonaSul-b20ae0b7c587c89de9f77e4d7816c792.png";